import { Injectable } from '@angular/core';
import { DataSourceRequestState, DataResult, toDataSourceRequestString, translateDataSourceResultGroups, SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { Observable, of } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { HttpRepo } from '@shared/services/httprepo';
import { AuthService } from '@services/auth.service';
import { ApiEndPointType } from '@shared/enums/common';
import { CommonMethods } from '@services/common.method';

@Injectable({
  providedIn: 'root'
})

export class JobsiteEquipmentService {

  constructor(
    private auth: AuthService,
    private httpRepo: HttpRepo,
    private commonMethod: CommonMethods
  ) {
    this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(), ApiEndPointType.FS);
  }


  public fetchEquipments(equipmentData: any, state: DataSourceRequestState, sort: SortDescriptor[]): Observable<DataResult> {
    //const hasGroups = state.group && state.group.length;
    return of({ data: equipmentData.Data, total: equipmentData.Count }) // Send the state to the server
      .map(({ data, total }: GridDataResult) => // Process the response
        (<GridDataResult>{
          data: data,
          total: total,
        })
      )
  }

  // Get List of Equipments
  GetEquipments(params: any, state: DataSourceRequestState) {
    return this.httpRepo.Get("customers/" + params.customerId + "/jobsites/" + params.jobsiteId + "/equipment", this.httpRepo.GetCommonURLQueryParams(state));
  }

  GetEquipmentDetail(params: any) {
    return this.httpRepo.Get("customers/" + params.customerId + "/jobsites/" + params.jobsiteId + "/Equipment/" + params.equipmentId + "?references=" + params.references);
  }

  CreateEquipment(params: any, data: any) {
    return this.httpRepo.Post("customers/" + params.customerId + "/jobsites/" + params.jobsiteId + "/Equipment", data);
  }

  //Update Equipment Detail
  UpdateEquipment(params: any, data: any) {
    return this.httpRepo.Put("customers/" + params.customerId + "/jobsites/" + params.jobsiteId + "/equipment/" + params.equipmentId, data);
  }

  //Delete Equipment
  DeleteEquipment(params: any) {
    return this.httpRepo.Delete("customers/" + params.customerId + "/jobsites/" + params.jobsiteId + "/equipment/" + params.equipmentId);
  }

  GetEquipmentHistory(params: any) {
    return this.httpRepo.Get("customers/" + params.customerId + "/jobsites/" + params.jobsiteId + "/equipment/" + params.equipmentId + "/history");
  }
}